<template>
  <main role="main" class="main bg-navy">
    <div class="bg-navy d-block d-md-none">
      <b-row class="no-gutters">
        <b-col class="text-center">
          <b-button type="button" variant="link" class="color-white float-left py-3" to="/home">
            <feather type="arrow-left"></feather>
          </b-button>
          <span class="d-inline-block h-100 title-w-60">
            <span class="d-table h-100">
              <span class="d-table-cell align-middle">
                <strong class="color-white">Users</strong>
              </span>
            </span>
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="mobile-vh min-h-100 p-4 p-md-5 bg-white mobi-rounded-top">
      <b-row class="custom-height">
        <b-col lg="10" offset-lg="1">
          <profile-menu></profile-menu>
          <h2 class="mobile-size-reduce color-navy-blue mb-3">Users</h2>
          <p class="line-height-1"><small><strong>Note:</strong> Individuals listed here must already be registered and verified users on the Truzo platform and would be granted permission to act on the behalf of the company as 'Registered Users'. Individuals listed in the 'Organisational Structure' are automatically added as users with their respective designations, they cannot be deleted here.</small></p>
          <div v-if="companyLoaded === 'loaded'">
            <b-table striped hover :items="companies.company.users" :fields="tableFields" :per-page="perPage" :current-page="currentPage" responsive="sm">
              <template v-slot:cell(relationship)="data">
                <span :class="data.item.relationship === 'Unknown' ? 'text-danger font-weight-600' : ''">
                  {{ data.item.relationship.replace(/,/g, ', ') }}
                  <small v-if="data.item.relationship === 'Unknown'"><br />Please, provide designation.</small>
                </span>
              </template>
              <template v-slot:cell(role)="data">
                <span>
                  {{ data.item.role.name }}
                </span>
              </template>
              <template v-slot:cell(_id)="data">
                <a href="#" @click.prevent="editUser(data.item._id)" v-if="data.item.relationship === 'Registered User' && myRole === 'Administrators'">
                  <feather type="edit" stroke="#9190a8" size="14px"></feather>
                </a>
                <a href="#" @click.prevent="deleteUser(data.item._id)" v-if="data.item.relationship === 'Registered User' && myRole === 'Administrators'">
                  <feather type="trash-2" stroke="#9190a8" size="14px"></feather>
                </a>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
              align="center"
              aria-controls="statement-table"
            ></b-pagination>
          </div>
          <div v-if="myRole === 'Administrators'">
            <hr style="width: 80%" />
            <b-row v-if="dual_authorization !== null">
              <b-col>
                <h5 class="mobile-size-reduce color-navy-blue mb-2">Dual Authorization</h5>
                <maz-checkbox v-model="dual_authorization">{{ dual_authorization === true ? 'Disable' : 'Enable' }} dual authorization for this company.</maz-checkbox>
                <p class="mt-1 mb-0"><small>
                  <b>Note:</b> Once dual authorization is enabled all payments to beneficiaries or own bank account with another institution will need to be authorized by a company user with appropriate authority. Users with <b>Administrators</b>, <b>Loaders</b>, and <b>Authorizers</b> roles can load new payments, only <b>Administrators</b> and <b>Authorizers</b> can authorize loaded payments and only if those payments haven't been loaded by themselves. <span v-if="roles.filter(_record => _record.name === 'Loaders' || _record.name === 'Authorizers').length <= 0"><b>Loaders</b> and <b>Authorizers</b> roles will be automatically added the first time you enable dual authorizations.</span>
                </small></p>
              </b-col>
            </b-row>
            <hr style="width: 80%" />
            <b-form>
              <h5 class="font-weight-400 color-grey mt-3 mb-2">Add New User</h5>
              <b-row class="mb-2 mt-3">
                <b-col md="6" class="pl-3">
                  <maz-input v-model="details.mobile" placeholder="Mobile Number" required :success="details.mobile && details.mobile.length >= 2"></maz-input>
                </b-col>
                <b-col md="6" class="pl-0">
                  <maz-input v-model="details.email" placeholder="Email Address" required :success="details.email && details.email.length >= 2"></maz-input>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col md="6" class="pl-3">
                  <maz-select v-model="details.role" placeholder="Role" clearable required :success="details.role !== null && details.role !== ''" :options="roles.map(_role => ({ value: _role.id, label: _role.name }))"></maz-select>
                </b-col>
              </b-row>
              <p class="color-grey mb-4" v-if="looking && (getUserStatus === 'not-found' || !details.user_id)">
                This individual is not registered with Truzo.
              </p>
              <b-form-group class="col-xl-12 btn-bottom px-md-0">
                <b-row>
                  <b-col lg="6" offset-lg="6" cols="12">
                    <loading-button :replace="saving !== null">
                      <b-button variant="custom" @click="save()" pill block class="mt-3" :disabled="!details.user_id">Add</b-button>
                    </loading-button>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Edit user modal -->
    <b-modal id="editUser" size="md" centered hide-header hide-footer v-if="editing && editing._id">
      <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('editUser')">×</button>
      <h3 class="color-navy-blue mb-4">Edit: {{ editing.name }}</h3>
      <b-form>
        <b-form-group>
          <maz-select v-model="editing.role.name" placeholder="New role" clearable required :success="editing.role.name !== null" :options="roles.map(_record => { return { label: _record.name, value: _record.name } })"></maz-select>
        </b-form-group>
        <p><small>
          Users with <b>Administrators</b>, <b>Loaders</b>, and <b>Authorizers</b> roles can load new payments, only <b>Administrators</b> and <b>Authorizers</b> can authorize loaded payments and only if those payments haven't been loaded by themselves.
        </small></p>
        <hr />
        <b-form-group>
          <b-row>
            <b-col cols="12" md="6" offset-md="6">
              <loading-button :replace="saving !== null">
                <b-button type="button" @click="saveEdit()" variant="custom" pill block class="mt-3">Save</b-button>
              </loading-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </b-modal>
    <!-- End edit user modal -->
  </main>
</template>

<script>
import { companyService } from '@/services'

import ProfileMenu from '@/components/organisation/ProfileMenu'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    ProfileMenu
  },
  data () {
    return {
      saving: null,
      editing: null,
      perPage: 10,
      currentPage: 1,
      looking: false,
      dual_authorization: null,
      tableFields: [
        { key: 'name', sortable: true, label: 'Name' },
        { key: 'email', sortable: true, label: 'Email' },
        { key: 'relationship', sortable: true, label: 'Designation' },
        { key: 'role', sortable: true, label: 'Role' },
        { key: '_id', sortable: false, label: 'Actions', class: 'text-right' }
      ],
      details: {
        designation: 'Registered User',
        designations: ['Registered User'],
        role: null,
        mobile: '',
        email: null,
        user_id: null
      },
      contact_schema: {
        fields: [
          {
            type: 'tel-input',
            label: 'Mobile number',
            placeholder: 'Mobile number',
            model: 'mobile',
            validator: ['telNumber'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'email',
            label: 'Email Address',
            placeholder: 'Email Address',
            model: 'email',
            validator: ['email'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'select',
            placeholder: 'Role',
            model: 'role',
            values: (model, schema) => {
              return this.roles
            },
            required: true,
            selectOptions: {
              noneSelectedText: 'Role',
              hideNoneSelectedText: false
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          }
        ]
      },
      formOptions: {
        validationErrorClass: 'has-error',
        validationSuccessClass: 'has-success',
        validateAfterChanged: false,
        validateAsync: true
      }
    }
  },
  computed: {
    ...mapState({
      accounts: state => state.companyAccounts,
      auth: state => state.auth.user,
      authExt: state => state.authExt,
      countries: state => state.country.countries,
      companies: state => state.company,
      compUser: state => state.companyUser
    }),
    getUserStatus () {
      return this.authExt.status
    },
    companyLoaded () {
      return this.companies.status
    },
    companyUserSaved () {
      return this.compUser.status === 'saved'
    },
    myRole () {
      if (this.auth && this.auth.user && this.auth.user.role) {
        return this.auth.user.role.name
      } else {
        return 'Unknown'
      }
    },
    roles () {
      if (this.companyLoaded === 'loaded') {
        const _roles = []
        this.companies.company.roles.forEach(role => {
          _roles.push({ id: role._id, name: role.name })
        })
        return _roles
      } else {
        return [{ id: null, name: 'None' }]
      }
    },
    totalRows () {
      return this.companies.company.users.length
    }
  },
  created () {
    this.getCompany()
  },
  methods: {
    ...mapActions('authExt', {
      getUser: 'getUser'
    }),
    ...mapActions('company', {
      getCompany: 'get'
    }),
    ...mapActions('companyUser', {
      addExisting: 'addExisting',
      deleteUser: 'delete',
      saveCompanyUser: 'save'
    }),
    editUser: function (id) {
      const _user = this.companies.company.users.find(_record => _record._id === id)
      if (_user) {
        this.editing = JSON.parse(JSON.stringify(_user))
        this.$nextTick(() => {
          this.$bvModal.show('editUser')
        })
      }
    },
    getCountry: function (code) {
      return this.countries.find(country => country.code === code).name
    },
    save: async function () {
      if (this.details.user_id) {
        this.saving = this.details.user_id
        this.addExisting({ id: this.saving, payload: this.details })
      }
    },
    saveEdit: function () {
      if (this.editing && this.editing._id) {
        const _roleId = this.roles.find(_record => _record.name === this.editing.role.name).id
        const _details = {
          designation: 'Registered User',
          designations: ['Registered User'],
          role: _roleId,
          mobile: this.editing.mobile,
          email: this.editing.email,
          user_id: this.editing._id
        }

        this.saving = _details.user_id
        this.addExisting({ id: this.saving, payload: _details })
      }
    }
  },
  watch: {
    companyLoaded: function (status) {
      if (status === 'loaded') {
        if (this.companies.company.dual_authorization) {
          this.dual_authorization = true
        } else {
          this.dual_authorization = false
        }
      }
    },
    companyUserSaved: function (value) {
      if (value) {
        this.getCompany()
        this.$bvModal.hide('edit_' + this.saving)
        this.$bvModal.hide('editUser')
        this.saving = null
        this.editing = null
        this.details = {
          designation: null,
          mobile: '',
          email: null,
          user_id: null
        }
      }
    },
    'details.mobile': function (value) {
      if (value && value.length >= 10) {
        this.looking = true
        this.getUser(value)
      }
    },
    'details.email': function (value) {
      if (value && value.length >= 10) {
        this.looking = true
        this.getUser(value)
      }
    },
    getUserStatus: function (value) {
      if (value === 'loaded') {
        this.details.user_id = this.authExt.user._id
      }
    },
    dual_authorization: async function (value, previous) {
      if (value === true && previous !== null) {
        await companyService.enableDualAuth(true)
        this.getCompany()
      } else if (previous !== null) {
        await companyService.enableDualAuth(false)
      }
    }
  }
}
</script>
